<script setup lang="ts">
import { onMounted, ref } from "vue";
import IconComponent from "../../components/ui/common/IconComponent.vue";
import { Menu } from "../../types/auth";
import { tokenManager } from "../../api/utils/tokenManager";

const isLoading = ref(false);

const activeMenus = ref<Menu[]>()
onMounted(async () => {
    const v = tokenManager.getMenu()
    if (!v) return;
    const cat = v.filter((o) =>
        Object.keys(o).some(() =>
        o['modules_id'] == null
        )
    );
    cat.forEach(c => {
        let cat_menu = v.filter((o) =>
            Object.keys(o).some(() =>
                o['modules_id'] == c.id
            )
        );
        cat_menu.forEach(n => {
            let mnu = v.filter((o) =>
                Object.keys(o).some(() =>
                    o['modules_id'] == n.id
                )
            );
            n.sub_menus = mnu
        });
        c.sub_menus = cat_menu
    });
    activeMenus.value = cat
});
</script>

<template>
  <div
    class="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 w-full self-start relative"
  >
  <div>
        <div class="text-left">
          <h2 class="text-2xl font-semibold mb-4">Welcome to Faseyha POS</h2>
          <p class="mb-6">You may chose any of the links below to proceed</p>
        </div>
      </div>
    <div
      class="absolute top-0 left-0 w-full h-full bg-blue-500 bg-opacity-50 flex items-center justify-center animate-blink"
    v-if="isLoading"
    >
      <IconComponent name="loading" class="animate-spin" />
    </div>
    <div v-else>
    <div class="flex space-x-4">
      <div v-for="menu in activeMenus" :key="menu.id" class="flex flex-col space-y-2">
        <div class="flex items-center space-x-2">
          <IconComponent :name="menu.icon_css" />
          <span class="text-lg font-medium text-gray-700 dark:text-gray-300">{{ menu.name }}</span>
        </div>
        <div v-if="menu.sub_menus" class="ml-6 mt-2">
          <div v-for="subMenu in menu.sub_menus" :key="subMenu.id" class="flex flex-col space-y-2 pt-3">
            <div class="flex items-center space-x-2">
              <IconComponent :name="subMenu.icon_css" />
              <h4 class="text-md font-semibold text-gray-600 dark:text-gray-400">{{ subMenu.name }}</h4>
            </div>
            <ul class="ml-6 mt-1">
              <li v-for="subSubMenu in subMenu.sub_menus" :key="subSubMenu.id" class="flex items-center space-x-2 pt-2">
                <IconComponent :name="subSubMenu.icon_css" />
                <router-link :to="subSubMenu.route_path" class="text-sm text-gray-500 dark:text-gray-400">
                  {{ subSubMenu.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
